import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ReportDistrictPage from "../components/ReportDistrictPage";

const ReportDistrict = () => {
  return (
    <div>
      <MasterLayout>
        <ReportDistrictPage />
      </MasterLayout>
    </div>
  );
};

export default ReportDistrict;
